import { Outlet } from 'react-router';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import Spinner from '@rio-cloud/rio-uikit/Spinner';

import AccessDeniedPage from '@/features/demofleet-player/components/AccessDeniedPage';
import { useCheckPermissionQuery } from '@/services/dfpFrontendApi';
import AppHeader from './header/AppHeader';

const AppLayout = () => {
    const { isLoading, error } = useCheckPermissionQuery();
    const isForbidden = error && 'status' in error && error.status === 403;

    const renderBody = () => {
        if (isLoading) {
            return (
                <div className="display-flex justify-content-center padding-top-50">
                    <Spinner />
                </div>
            );
        }

        if (isForbidden) {
            return <AccessDeniedPage />;
        }

        return <Outlet />;
    };

    return (
        <ApplicationLayout>
            <ApplicationLayout.Header>
                <AppHeader />
            </ApplicationLayout.Header>
            <ApplicationLayout.Body>{renderBody()}</ApplicationLayout.Body>
        </ApplicationLayout>
    );
};

export default AppLayout;
